import { render, staticRenderFns } from "./Punching.vue?vue&type=template&id=bf505f4c&scoped=true"
import script from "./Punching.vue?vue&type=script&lang=js"
export * from "./Punching.vue?vue&type=script&lang=js"
import style0 from "./Punching.vue?vue&type=style&index=0&id=bf505f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf505f4c",
  null
  
)

export default component.exports